
import React from 'react';

export const ChevronRightIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    chevron_right
  </span>
);